import { Core } from "@faire/design-tokens";
import { setTimeoutIfPossible } from "@faire/next-utils/isomorphic/setTimeoutIfPossible";
import { Footer } from "@faire/retailer-visitor-shared/components/Footer/index";
import { getGlobalProperty } from "@faire/web--source/common/globals/getGlobalProperty";
import * as Font from "@faire/web--source/slate/Font";
import { Column } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import React, { useEffect } from "react";
import styled from "styled-components";

export const CookiePolicy: React.FC = () => {
  useEffect(() => {
    // Timeout 1s in order to wait for OneTrust script to finish loading
    setTimeoutIfPossible(() => {
      const OneTrust = getGlobalProperty<{
        initializeCookiePolicyHtml?: () => void;
      }>("OneTrust");
      OneTrust?.initializeCookiePolicyHtml?.();
    }, 1000);
  }, []);

  return (
    <Wrapper>
      <ContentWrapper>
        <div id="ot-sdk-cookie-policy" />
      </ContentWrapper>
      <Column>
        <button id="ot-sdk-btn" className="ot-sdk-show-settings" />
        <Spacer size={30} />
      </Column>
      <Footer />
    </Wrapper>
  );
};

const Wrapper = styled(Column).attrs({
  align: "center",
})`
  width: 100%;
  padding: 40px 0px;

  #ot-sdk-btn.ot-sdk-show-settings,
  #ot-sdk-btn.optanon-show-settings {
    background-color: ${Core.text.default};
    color: ${Core.text.inverse};
    border-color: ${Core.text.default};
    padding: 15px 40px;
  }

  #ot-sdk-btn.ot-sdk-show-settings:hover,
  #ot-sdk-btn.optanon-show-settings:hover {
    background-color: ${Core.surface
      .disabled}; // TODO replace with non-disabled token

    border-color: ${Core.border.subdued};
  }
`;

const ContentWrapper = styled(Column)`
  width: 100%;
  max-width: 900px;

  table {
    border-radius: 0 !important;
  }

  font-family: ${Font.Family.sansSerif};

  th,
  td,
  p,
  h3,
  div {
    font-weight: ${Font.Weight.book} !important;
  }

  #cookie-policy-title {
    font-family: ${Font.Family.serif};
    font-size: 28px;
  }
`;
